import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import { components } from 'react-select';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import { SORT_BY_NEW_POPULAR_BOOKS } from 'rebook/apps/base/constants';
import Select from 'rebook/apps/base/components/Select';

import styles from './style.scss';


class OrderByNewPopular extends React.Component {
  onChange(orderBy) {
    this.props.history.push({
      search: fixQueryString(get(this, 'props.location.search', ''), { o: orderBy.value }),
    });
    this.props.onChange(orderBy.value);
  }

  subscriptionOption(props) {
    return (
      <components.Option {...props}>
        <div className={styles.optionTextContainer}>
          <span>{props.children}</span>
        </div>
      </components.Option>
    );
  }

  subscriptionValueContainer(props) {
    return (
      <div className={styles.valueTextContainer}>
        <components.ValueContainer {...props} />
      </div>
    );
  }

  render() {
    const { orderBy, orderByValues } = this.props;
    const value = orderByValues.find((item) => (item.value === orderBy));

    return (
      <Select
        name="order"
        options={orderByValues}
        value={value}
        width={this.props.width}
        onChange={(value) => this.onChange(value)}
        isDisabled={this.props.isDisabled}
        components={{
          Option: this.subscriptionOption,
          ValueContainer: this.subscriptionValueContainer,
        }} />
    );
  }
}

OrderByNewPopular.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  width: PropTypes.number,
  orderBy: PropTypes.oneOf([
    'popular', 'new', 'readers', 'reviews', 'asc', 'weight', 'book_count',
  ]),
  orderByValues: PropTypes.array,
};

OrderByNewPopular.defaultProps = {
  isDisabled: false,
  width: 200,
  orderBy: 'new',
  orderByValues: SORT_BY_NEW_POPULAR_BOOKS,
  onChange: function() {},
};

export default withRouter(OrderByNewPopular);
